import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiUser, FiLogOut, FiMenu, FiX } from "react-icons/fi";

function Header({ openLogin, openSignup }) {
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  // 🔹 NEW: ref for outside click
  const dropdownRef = useRef(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  // 🔹 NEW: close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  const handleProfile = () => {
    setShowDropdown(false);
    if (user.role === "partner") {
      navigate("/partner-profile");
    } else {
      navigate("/customer-profile");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setShowDropdown(false);
    window.location.reload();
  };

  const getDisplayName = () => {
    if (!user) return "";
    if (user.role === "partner") {
      return user.owner_name || user.businessName || "Partner";
    }
    return user.full_name || user.fullName || "Customer";
  };

  const getInitials = () => {
    const name = getDisplayName();
    return name
      .split(" ")
      .map(n => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const handleMenuItemClick = () => {
    setShowMobileMenu(false);
  };

  return (
    <>
    {/* 🔹 TOP NAVBAR */}
      <div className="top-navbar">
        <div className="top-navbar-links">
          <a href="https://soft.krivabharat.com/" target="_blank" rel="noopener noreferrer">FMS</a>
          <a href="https://krivamail.com/" target="_blank" rel="noopener noreferrer">Kriva Mail</a>
        </div>
      </div>
    <header className="header">
      <div className="logo-container">
        <div className="logo-icon">
          <img src="/TimeEdgeIcon.png" alt="Kriva Bharat Logo" />
        </div>
        <div className="logo-text">
          <div className="logo-main">Kriva Bharat</div>
          <div className="logo-sub">Private Limited</div>
        </div>
      </div>

      <button 
        className="hamburger-menu"
        onClick={() => setShowMobileMenu(!showMobileMenu)}
        aria-label="Toggle menu"
      >
        {showMobileMenu ? <FiX size={24} /> : <FiMenu size={24} />}
      </button>

      <nav className={`header-menu ${showMobileMenu ? 'active' : ''}`}>
        <a href="/" className="menu-item" onClick={handleMenuItemClick}>Home</a>
        <a href="/about-us" className="menu-item" onClick={handleMenuItemClick}>About</a>
        <a href="/services" className="menu-item" onClick={handleMenuItemClick}>Service</a>
        <a href="/contact" className="menu-item" onClick={handleMenuItemClick}>Contact</a>
        
        {!user && (
          <button 
            className="mobile-login-btn" 
            onClick={() => {
              openLogin();
              handleMenuItemClick();
            }}
          >
            Login
          </button>
        )}
      </nav>

      <div className="header-btns">
        {user ? (
          <div className="profile-section" ref={dropdownRef}>
            <div
              className="profile-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <div className="profile-avatar">{getInitials()}</div>
              <div className="profile-info-header">
                <span className="profile-name">{getDisplayName()}</span>
                <span className="profile-role-badge">{user.role}</span>
              </div>
              <span className="dropdown-arrow">▼</span>
            </div>

            {showDropdown && (
              <div className="profile-dropdown">
                {/* 🔹 NEW: header with close button */}
                <div className="dropdown-header">
                  <div className="dropdown-item profile-info">
                    <p className="user-email">{user.email}</p>
                    <span className="user-role">{user.role}</span>
                  </div>

                  <span
                    className="dropdown-close"
                    onClick={() => setShowDropdown(false)}
                  >
                    &times;
                  </span>
                </div>

                <div className="dropdown-divider"></div>

                <div className="dropdown-item" onClick={handleProfile}>
                  <FiUser className="dropdown-icon" />
                  Profile
                </div>

                <div className="dropdown-item" onClick={handleLogout}>
                  <FiLogOut className="dropdown-icon" />
                  Logout
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            <button className="top-btn" onClick={openLogin}>
              Login
            </button>
           
          </>
        )}
      </div>
    </header>
    </>
  );
}

export default Header;
